export default class Manager {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        managerRetrieve(id: ${id}) {
          id
          sendNotif
          user {
            id
            username
            firstName
            lastName
            email
          }
          company {
            id
            active
            name
            description
            closeTime
            images {
              id
              url
            }
            logo {
              id
              url
            }
            openTime
            phoneNumber
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.managerRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        managerList(affiliate: ${payload.affiliate}) {
            id
            sendNotif
            user {
              id
              username
              firstName
              lastName
              email
            }
            company {
              id
              active
              name
              description
              closeTime
              images {
                id
                url
              }
              logo {
                id
                url
              }
              openTime
              phoneNumber
            }
          }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i=0; i < response.data.data.managerList.length; i++) {
      response.data.data.managerList.sendNotif = response.data.data.managerList.sendNotif ? "SI" : "NO";
    }

    return response.data.data.managerList.reverse();
  }

  // static async filter(axios, branchOffice) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       employmentList (branchOffice: ${branchOffice}) {
  //         results {
  //           id
  //           user{
  //             id
  //             username
  //             firstName
  //             lastName
  //             email
  //           }
  //           branchOffice {
  //             id
  //             active
  //             name
  //             description
  //             closeTime
  //             openTime
  //             phoneNumber
  //             company {
  //               id
  //               name
  //             }
  //             address {
  //               id
  //               street
  //               unit
  //               houseNumber
  //               postCode
  //               latitude
  //               longitude
  //               city {
  //                 id
  //                 name
  //                 region {
  //                   id
  //                   name
  //                   country {
  //                     id
  //                     name
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //
  //   return response.data.data.employmentList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteManager(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteManager.ok;
  }

  static async create(axios, user, company, sendNotif) {
    const response = await axios.post(
      '/graphql/',
      `mutation {
        createManager(newManager: {
          user: ${user}, 
          company: ${company},
          sendNotif: ${sendNotif}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createManager.ok;
  }


  static async edit(axios, id, user, company, sendNotif) {
    const userField = (user > 0) ? `user: ${user},` : ``;
    const companyField = (company > 0) ? `company: ${company},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation {
        updateManager(newManager: {
          ${userField}
          ${companyField}
          sendNotif: ${sendNotif},
          id: ${id},
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateManager.ok;
  }


}
